<template>
  <q-layout class="afk-auth-layout">
    <!-- Background -->
    <div class="afk-auth-bg">
      <div class="afk-auth-bg__grain" />
      <div class="afk-auth-bg__circle afk-auth-bg__circle--lg" />
      <div class="afk-auth-bg__circle afk-auth-bg__circle--md" />
      <div class="afk-auth-bg__circle afk-auth-bg__circle--sm" />
    </div>

    <q-page-container>
      <router-view />
    </q-page-container>

    <!-- Footer links -->
    <div class="afk-auth-footer">
      <div class="afk-auth-footer__links">
        <router-link to="/auth/login">Login</router-link>
        <router-link to="/terms/terms-and-conditions">Terms</router-link>
        <router-link to="/terms/privacy-policy">Privacy</router-link>
        <a href="https://www.additivefreekids.com.au" target="_blank">
          Website
          <q-icon name="mdi-open-in-new" size="11px" />
        </a>
      </div>
      <div class="afk-auth-footer__meta">
        <span>v{{ version }}</span>
        <img
          src="/images/logo-powered-by-nano.png"
          alt="Powered By Nano Solutions"
          class="afk-auth-footer__nano"
        />
      </div>
    </div>
  </q-layout>
</template>

<script>
export default {
  name: "AuthLayout",
  computed: {
    version() {
      return window.APP_VERSION || "unknown";
    },
  },
};
</script>

<style>
:root {
  --afk-bg: #f8f7f5;
  --afk-teal-dark: #0e4a52;
  --afk-teal: #165c65;
  --afk-teal-light: #59c4c0;
  --afk-coral: #96282c;
  --afk-text: #2c2c2c;
  --afk-muted: #7a7a7a;
}

body {
  background: var(--afk-bg);
  -webkit-font-smoothing: antialiased;
  margin: 0;
}

/* ─── AUTH BACKGROUND ─── */
.afk-auth-bg {
  position: fixed;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
  background: linear-gradient(
    135deg,
    #0e4a52 0%,
    #165c65 40%,
    #1a6e78 70%,
    #59c4c0 100%
  );
}

.afk-auth-bg__grain {
  position: absolute;
  inset: 0;
  opacity: 0.04;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
  background-repeat: repeat;
  background-size: 200px;
  pointer-events: none;
}

.afk-auth-bg__circle {
  position: absolute;
  border-radius: 50%;
}

.afk-auth-bg__circle--lg {
  width: 420px;
  height: 420px;
  background: rgba(89, 196, 192, 0.08);
  top: -140px;
  right: -100px;
}

.afk-auth-bg__circle--md {
  width: 240px;
  height: 240px;
  background: rgba(255, 255, 255, 0.04);
  bottom: -80px;
  left: 8%;
}

.afk-auth-bg__circle--sm {
  width: 100px;
  height: 100px;
  background: rgba(89, 196, 192, 0.06);
  top: 60%;
  right: 30%;
}
</style>

<style scoped>
.afk-auth-layout {
  min-height: 100vh;
}

/* Footer */
.afk-auth-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  z-index: 10;
}

.afk-auth-footer__links {
  display: flex;
  gap: 20px;
}

.afk-auth-footer__links a {
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  transition: color 0.15s ease;
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.afk-auth-footer__links a:hover {
  color: rgba(255, 255, 255, 0.85);
}

.afk-auth-footer__meta {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.35);
  font-family: monospace;
}

.afk-auth-footer__nano {
  width: 12px;
  height: auto;
  opacity: 0.4;
}

@media (max-width: 599px) {
  .afk-auth-footer {
    position: relative;
    flex-direction: column;
    gap: 8px;
    padding: 20px 16px;
  }
}
</style>
